export const SET_USER_INFOS = 'SET_USER_INFOS'
export const SET_USER_TOKEN = 'SET_USER_TOKEN'
